// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V7yUaHbrDavjt5 {
  display: flex;
}
.OPJCGBBFdTqVba {
  display: flow-root;
  position: relative;
  z-index: 10;
  min-height: 24px;
  padding: 8px 12px 4px;
}
.xhHnIObZcCdpqs {
  display: none;
  min-width: 20px;
}
.OPJCGBBFdTqVba:hover .xhHnIObZcCdpqs {
  display: block;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardName": `V7yUaHbrDavjt5`,
	"details": `OPJCGBBFdTqVba`,
	"externalLinkIcon": `xhHnIObZcCdpqs`
};
export default ___CSS_LOADER_EXPORT___;
